import * as React from 'react';
import { InputBaseModel } from '../models';

export default (input: InputBaseModel, inputAction: () => void) => {
    const [focusedValue, setFocusedValue] = React.useState<unknown>(null);

    const handleFocus = React.useCallback(() => {
        setFocusedValue(input.value);
    }, [input.value]);

    const handleBlur = React.useCallback(() => {
        if (focusedValue !== input.value) {
            inputAction();
        }

        setFocusedValue(null);
    }, [focusedValue, input.value, inputAction]);

    const handleKeyDown = React.useCallback((event: React.KeyboardEvent) => {
        if (event.key === 'Enter' && event.currentTarget instanceof HTMLElement) {
            event.currentTarget.blur();
        }
    }, []);

    return {
        handleFocus,
        handleBlur,
        handleKeyDown
    };
};
